(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wn-base-styles"] && !Shopify.designMode) return;
  try {
    (function () {
    function scrollTopOf(e) {
      var t = e && e.target;
      if (t && t !== document && t.scrollTop !== undefined) return t.scrollTop;
      return window.scrollY || document.documentElement.scrollTop || 0;
    }
    var ticking = false, lastY = 0;
    function update() {
      document.querySelectorAll('.wn-hdr').forEach(function (h) { h.classList.toggle('is-scrolled', lastY > 40); });
      document.querySelectorAll('[data-wn-progress]').forEach(function (bar) {
        var body = document.querySelector('.blog-post-content');
        if (!body) return;
        var r = body.getBoundingClientRect(), h = r.height - window.innerHeight * 0.6;
        var p = h > 0 ? Math.min(1, Math.max(0, -r.top / h)) : 0;
        bar.style.transform = 'scaleX(' + p + ')';
      });
      ticking = false;
    }
    document.addEventListener('scroll', function (e) {
      lastY = scrollTopOf(e);
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { capture: true, passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
